/* jshint esversion: 6, -W097 */
/* globals module */
"use strict";

/*
    Creates a new controller for the flat pages called "SpecialOffersCtrl"
*/
SpecialOffersCtrl.$inject = [
    'CmsContentService',
    'SpecialOffersService',
    'UtilService',
];
function SpecialOffersCtrl(
    CmsContentService,
    SpecialOffersService,
    UtilService
) {
    const vm = this;
    vm.loadingOffers = true;
    vm.heroImage = UtilService.getSiteSetting('special_offers_hero_image');

    SpecialOffersService.getCategories().then(categoryLists => {
        vm.instantDiscountCategories = categoryLists[0];
        vm.rebatableCategories = categoryLists[1];
        vm.loadingOffers = false;
    });

    CmsContentService.getMarketPlaceText('special_offers:title').then(text => {
        vm.title = text;
    });

    CmsContentService.getMarketPlaceText('special_offers:instant_discount_title').then(text => {
        vm.instantDiscountTitle = text;
    });

    CmsContentService.getMarketPlaceText('special_offers:rebatable_title').then(text => {
        vm.rebatableTitle = text;
    });

    CmsContentService.getMarketPlaceText('special_offers:action_button_text').then(text => {
        vm.actionButtonText = text;
    });

    CmsContentService.getMarketPlaceText('special_offers:loading_text').then(text => {
        vm.loadingText = text;
    });
}

module.exports = SpecialOffersCtrl;